<template>
	<div id="tc-page" class="wp_AllPageMarginTop">
		<h5 style="text-align:center;" class="mb-4"
						data-test="termsAndConditionHeading1"
						id="termsAndConditionHeading1">
			THE NEO BANK
		</h5>
		<h5 style="text-align:left;"
						data-test="termsAndConditionHeading2"
						id="termsAndConditionHeading2"
		>
			Privacy Policy
		</h5>
		<div v-for="(account, index) in privacyData" :key="index">
			<p data-test="termsAndConditionPara1"
						id="termsAndConditionPara1" :style="account.isHead?'font-weight:bold':''">
				<!--<b data-test="termsAndConditionParaBold1"-->
				<!--id="termsAndConditionParaBold1">Personal Information:</b>-->
				{{account.body}}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			privacyData: [
				{
					body: 'This Online Privacy Policy (“Policy”) applies to your interaction with The Neobank Inc. or any of its subsidiaries (collectively, “The Neobank,” “we,” “us,” and “our”), at any online or mobile site or application that we own and control (“Site”), unless a different online and/or mobile privacy policy is posted, or is made available and by its terms supersedes this Policy. Other privacy policies may apply in addition to this one. Examples:  the Privacy Notice that applies to our U.S. customers or an additional privacy policy in connection with your use of a specific product or relationship you may have with one of our lines of business. This Policy explains how we protect and use certain data, as well as describing practices affecting online ads we place on third party sites. If we do appear on a third party site, that party’s privacy policy and terms of use, not ours, will govern your visit to its site.',
					isHead: false
				}, {
					body: 'By using the Site or clicking on our ad, wherever it appears, you are consenting to the applicability of the terms of this Policy, including your consent to our ability to use and disclose information about you in the manner described below.',
					isHead: false
				}, {
					body: 'By interacting with us online or via a mobile device, you may visit our Site or use our application: registration is not required to browse. Information we may collect about you through your online visits includes information that you give to us, such as: name, address, email address, or other contact information, and location information. We may also collect information about you such as the type of device and browser you are using, the IP address of your device, information about the device’s operating system and additional information associated with your device. We may also collect information through cookies, tags, and other technologies:',
					isHead: false
				}, {
					body: 'Cookies are pieces of data stored on your device. Browser cookies are assigned by a web server to the browser on your device. When you return to a site you have visited before, your browser gives this data back to the server. Mobile apps may also use cookies.',
					isHead: false
				}, {
					body: 'Cookies and the information they provide are used to make your visits to our Site and certain others more personalized. For instance, information provided by cookies may be used to make offers to you via online ads, email, postal mail, or telephone, subject to the privacy preferences you have provided to us. We also use cookies, sometimes with the help of third-party service providers, when we advertise on our Site or on third party sites. This helps us determine which ads appeal to you and other visitors.',
					isHead: false
				}, {
					body: 'Because we respect your need to exercise choice when it comes to receiving our ads on other sites, we use the Advertising Options icon sponsored through aboutads.info. Visiting aboutads lets you use another cookie to opt-out of receiving our ads. However, if you delete cookies, use a different device, or change web browsers, you will need to opt out again.',
					isHead: false
				}, {
					body: 'When you visit our Site, other parties may collect information about your web browsing behavior on our behalf and not for the benefit of any other party. However, because we provide certain widgets, tools, or information on our Site (e.g., your ability to share information on a social media site, or access to a map for directions) these items will involve the use of cookies by the third party host of the site. This means the third party host will have access to information about your web browsing on the pages of our Site where those items are available.',
					isHead: false
				}, {
					body: 'We also use cookies for purposes such as maintaining continuity during an online session; gathering data about how our Site is used; and for anti-fraud and information security uses.',
					isHead: false
				}, {
					body: 'If you set your browser to reject cookies, you may find that the functionality of our Site is limited. The latest version of your browser may provide cookie management tools. You should refer to the information supplied for your browser to determine what you can or cannot do with respect to cookies.',
					isHead: false
				}, {
					body: 'We may also use technology such as pixel tags, web beacons, and clear GIFs, and may permit our third party service providers to also use them on our behalf. These technologies are used to measure the effectiveness of our ads, to determine viewing and response rates, and to decide which offers to present to you on the Site or on third party sites.',
					isHead: false
				},
				{
					body: 'In addition, we use the information we gather for such lawful purposes as providing service; improving our Site, products, and service; legal compliance; risk control; information security, anti-fraud; marketing and/or personalizing the product or service offers we make to you; and tracking use of our Site, i.e., number of hits, pages visited, duration of user visits.',
					isHead: false
				}, {
					body: 'We do not knowingly solicit or collect personal information from children under the age of 13, without parental consent to do so.',
					isHead: false
				}, {
					body: 'To the extent that we receive, maintain, or process your protected health information, we may disclose that information as authorized by and in accordance with any applicable federal and/or state law or regulation.',
					isHead: false
				}, {
					body: 'We may share information with our service providers, such as data processors and companies that help us market products and services to you. When permitted or required by law, we may share information with other third parties for purposes including response to legal process.',
					isHead: false
				}, {
					body: 'This Policy is subject to change. Please review it periodically. If we make changes, we will revise the “Last Updated” date at the bottom of this Policy. Any changes will be effective when we post the revised Policy on the Site. Your use of the Site after we post it means you accept the revised Policy.',
					isHead: true
				}
			]
		}
	}
}
</script>

<style lang="scss">
	#tc-page {
		font-family: "Nunito Sans", sans-serif;
		text-align: justify;
		padding: 35px;
		padding-top: 70px;

		b {
			color: rgb(63, 63, 63);
		}
	}
</style>
